import React from 'react';
import { Award } from 'lucide-react';

interface TopScannedBook {
  title: string;
  uibn: string;
  scanCount: number;
}

interface TopScannedLeaderboardProps {
  topScanned: TopScannedBook[];
}

export const TopScannedLeaderboard: React.FC<TopScannedLeaderboardProps> = ({ topScanned }) => {
  return (
    <div className="bg-white p-5 rounded-2xl border border-slate-200/90 shadow-2xs space-y-3">
      <div className="flex items-center justify-between">
        <h3 className="text-sm font-bold text-slate-900">Buku Paling Sering Dipindai</h3>
        <Award className="w-4 h-4 text-amber-500" />
      </div>

      <div className="space-y-2 pt-1">
        {topScanned.length === 0 ? (
          <p className="text-xs text-slate-400 py-4 text-center">Belum ada pemindaian tercatat.</p>
        ) : (
          topScanned.map((b, i) => (
            <div
              key={b.uibn}
              className="flex items-center justify-between p-2.5 rounded-xl bg-slate-50 border border-slate-100 text-xs"
            >
              <div className="flex items-center gap-2.5 min-w-0">
                <span className="w-5 h-5 rounded-full bg-slate-200 text-slate-700 font-bold text-[10px] flex items-center justify-center shrink-0">
                  {i + 1}
                </span>
                <div className="min-w-0">
                  <p className="font-semibold text-slate-900 truncate">{b.title}</p>
                  <p className="text-[11px] text-slate-400 font-mono">{b.uibn}</p>
                </div>
              </div>
              <span className="px-2 py-1 rounded-md bg-indigo-50 text-indigo-700 font-bold shrink-0 text-[11px]">
                {b.scanCount} scan
              </span>
            </div>
          ))
        )}
      </div>
    </div>
  );
};
